
import { NgClass } from '@angular/common';
import { Component, OnInit, computed, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonSelectField } from '../field';
import { getLabels } from '../field.labels';


@Component({
	selector: 'common-select-field',
	imports: [FormsModule, NgClass],
	templateUrl: './common-select-field.widget.html',
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonSelectFieldWidget<T> extends CommonFieldWidgetBase<T, CommonSelectField<T>> implements OnInit {

	public readonly field = input.required<CommonSelectField<T>>();

	public readonly labels = computed(() => getLabels(this.field().config().isSpanish));

	public readonly renderedModel = computed(() => {
		const value = this.field().pendingValue() ?? this.field().actualValue();
		return this.render(value);
	});

	public readonly customIcon = computed(() => {
		return this.field().config().options.find(option => option.value == this.field().actualValue())?.icon || null;
	});

	public readonly defaultValue = computed(() => {
		const actualValue = this.field().actualValue();
		// If the actual value is undefined or null, return it directly as the default value.
		if (actualValue === undefined || actualValue === null) return actualValue;
		return typeof actualValue == 'number' ? 0 : '';
	});


	ngOnInit() {
		this.onInit(this.field());
	}

	// using ngValue in the template to avoid string coercion
	public onChange(value: T) {
		this.processChange(value);
	}

	public async onBlur() {
		await this.processBlur();
	}


	protected validate(value: T): string {

		const config = this.field().config();

		if (this.isEmpty(value) && config.isRequired) return this.labels().missingRequired();

		return '';
	}

	private isEmpty(value: T): boolean {
		if (value === null || value === undefined) return true;

		switch (typeof value) {
			case 'boolean':
				return false; // booleans always have a valid value
			case 'number':
				return isNaN(value) || value === 0; // considering 0 as empty for numbers
			case 'string':
				return value.length === 0 || value.trim() === '';
			default:
				return false;
		}
	}

	public setFocus() {
		console.error('setFocus() not implemented');
	}

}